import { render, staticRenderFns } from "./AppMobileConfig.vue?vue&type=template&id=c548cfca&scoped=true"
import script from "./AppMobileConfig.vue?vue&type=script&lang=js"
export * from "./AppMobileConfig.vue?vue&type=script&lang=js"
import style0 from "./AppMobileConfig.vue?vue&type=style&index=0&id=c548cfca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c548cfca",
  null
  
)

export default component.exports